"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Toggle({ active, onClick }) {
    return (react_1.default.createElement("button", { onClick: onClick
            ? () => {
                onClick();
            }
            : () => { }, role: "checkbox", tabIndex: 0, "aria-checked": "false", className: `${active ? 'bg-highlight-600' : 'bg-gray-200 dark:bg-gray-700'} relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring` },
        react_1.default.createElement("span", { "aria-hidden": "true", className: `${active ? 'translate-x-5' : 'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200` })));
}
exports.default = Toggle;
